import React from 'react';

type Props = {
    size?: {
        width: number;
        height: number;
    };
};

export const MenuRightIcon = ({size = {width: 24, height: 24}}: Props) => {
    return (
        <svg
            width={size.width}
            height={size.height}
            viewBox='0 0 24 24'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M10,17L15,12L10,7V17Z' />
        </svg>
    );
};
